import React from 'react';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import Button from '../../../../../components/button';
import { StepIndicator } from './components/StepIndicator';

type NavigationButtonsProps = {
  onBack: () => void;
  onNext?: () => void;
  disableBack?: boolean;
  disableNext?: boolean;
  isSubmitting?: boolean;
  currentStep: number;
  totalSteps: number;
};

export const NavigationButtons: React.FC<
  React.PropsWithChildren<NavigationButtonsProps>
> = ({
  onBack,
  onNext,
  disableNext = false,
  disableBack = false,
  isSubmitting = false,
  currentStep,
  totalSteps,
}) => {
  const isLastStep = currentStep === totalSteps - 1;
  const t = useNamespacedTranslation('changeRequests.requestForm');

  const handleNext = () => {
    if (onNext) {
      onNext();
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-between flex-grow-1">
      <div>
        <Button
          variant="outline-primary"
          label={t('buttons.back')}
          onClick={onBack}
          disabled={disableBack}
        />
      </div>
      <div className="text-center">
        <StepIndicator totalSteps={totalSteps} currentStep={currentStep + 1} />
      </div>
      <div className="text-end">
        <Button
          type={isLastStep ? 'submit' : 'button'}
          variant="primary"
          label={isLastStep ? t('buttons.confirm') : t('buttons.next')}
          disabled={disableNext}
          onClick={handleNext}
          isProcessing={isSubmitting}
        />
      </div>
    </div>
  );
};
